import {
  MARKETING_EXPERIMENTS,
  experimentVariant,
  validExperimentExposures,
} from "../../shared/marketingExperiments";
import { trackBlissFunnelEvent } from "./funnelAnalytics";
const KEY = "bliss_experiment_exposures";
function visitorId() {
  const current = document.cookie
    .split("; ")
    .find((v) => v.startsWith("bliss_experiment_visitor="))
    ?.split("=")[1];
  if (current && /^[a-f0-9-]{36}$/i.test(current)) return current;
  const id = crypto.randomUUID(),
    shared = /(^|\.)blissbunkbeds\.com$/.test(location.hostname)
      ? "; Domain=blissbunkbeds.com"
      : "";
  document.cookie = `bliss_experiment_visitor=${id}; Path=/; Max-Age=7776000; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}${shared}`;
  return document.cookie.includes(`bliss_experiment_visitor=${id}`) ? id : null;
}
/** Future variant components call this only for an owner-enabled experiment. */
export function assignedMarketingVariant(id: string): string | null {
  const test = MARKETING_EXPERIMENTS.find((t) => t.id === id && t.enabled);
  if (!test || typeof document === "undefined") return null;
  try {
    const visitor = visitorId();
    return visitor ? experimentVariant(test, visitor) : null;
  } catch {
    return null;
  }
}
/** Call after the tested content is actually displayed; assignment alone is not exposure. */
export function recordMarketingExposure(id: string, variant: string) {
  const test = MARKETING_EXPERIMENTS.find((t) => t.id === id && t.enabled);
  if (!test || !test.variants.includes(variant)) return;
  try {
    const exposures = readMarketingExposures();
    if (exposures.some((x) => x.id === id)) return;
    sessionStorage.setItem(
      KEY,
      JSON.stringify([
        ...exposures,
        { id, variant, exposedAt: new Date().toISOString() },
      ]),
    );
    trackBlissFunnelEvent("experiment_exposure", {
      experiment_id: id,
      variant,
    });
  } catch {
    /* Analytics never blocks the customer. */
  }
}
export function readMarketingExposures() {
  try {
    return validExperimentExposures(
      JSON.parse(sessionStorage.getItem(KEY) || "[]"),
    );
  } catch {
    return [];
  }
}
